module.exports = __webpack_public_path__ + "img/icon-hamburger.2aa86d64.svg";